import { render, staticRenderFns } from "./ModelViewer.vue?vue&type=template&id=ad561384&scoped=true&"
import script from "./ModelViewer.vue?vue&type=script&lang=js&"
export * from "./ModelViewer.vue?vue&type=script&lang=js&"
import style0 from "./ModelViewer.vue?vue&type=style&index=0&id=ad561384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad561384",
  null
  
)

export default component.exports